// WooCommerce bundle — enqueued only on shop pages (trigger in src/modules/woocommerce.json)
require('./single-product');
require('./products');
